module.exports = {
  _init: function () {
    APPLICATION.PodConfigurator.modals.createPopup.setupModal("confirm")
    this.onChangeNodes();
    this.onConfirm();
  },

  onChangeNodes: function () {
    $("#pods")
      .not(".js-ignore")
      .on("keyup change", function () {
        var pods = parseInt($(this).val() || 0);
        
        var max = parseInt($(this).attr("max") || 0)
        if (pods > max) {
          pods = max;
        }

        $(this).val(pods)

        var pods_total = pods * parseFloat($("#pods-price").val() || 0.0);

        $("#pods-total").text(
          Number(pods_total).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        );
      })
      .addClass("js-ignore");
  },

  onConfirm: function () {
    $(".js-confirm")
      .not(".js-ignore")
      .click(function () {
        let pods = $("#pods").val()
        APPLICATION.PodConfigurator.modals.createPopup.resetModal()
        APPLICATION._APPLICATION.customModal(
          "/pod-configurator/terms?pods=" + pods,
          "PodConfigurator",
          "terms"
        );
      })
      .addClass("js-ignore");
  },
  
};
